export default __webpack_public_path__ + "static/media/Icons_Notifications Icon.5df29b06.svg";